import { gql } from "@apollo/client";

export const CHANGE_EMAIL = gql`
    mutation changeEmail($newEmail: String!) {
        changeEmail(newEmail: $newEmail) {
            id
        }
    }
`;